<div class="page gray-font-color font-family bodyBackground processing-request">
  @if (errorMessage) {
    <mat-error class="error padding-left-md">
      {{ errorMessage }}
    </mat-error>
  }
  <div class="header-navigation-back">
    <div class="back-icon" (click)="navigateBack()" data-test="back-arrow-icon" data-testid="back-arrow-icon">
      <mat-icon svgIcon="left-arrow"></mat-icon>
    </div>
    @if (!isStripeSessionActive) {
      <span class="title">{{ documentName }}</span>
    }
    @if (isStripeSessionActive) {
      <span class="title">Order PCC</span>
    }
  </div>
  @if (loading) {
    <app-loading-gif></app-loading-gif>
  }
  @if (!loading && !isStripeSessionActive) {
    <div class="processing-container" (swipeleft)="navigateBack()" (swiperight)="onSwipeRight($event)">
      <div class="processing-label">
        Processing your request
      </div>
      @if (!enableStripePayment) {
        <div class="processing-info">
          <h3 class="info-heading">Next Steps</h3>
          <p class="info-content" data-test="driver-info" data-testid="driver-info">
            You will be required to scan your ID in order to process your Criminal Record Check report.
          </p>
          <p class="info-content" data-test="info-content" data-testid="info-content">
            You will receive an email at <span class="info-email" data-test="driver-email" data-testid="driver-email">{{ driverEmail }}</span> with
            instructions, when the Carrier processes your request.
          </p>
        </div>
      }
      @if (enableStripePayment) {
        <div class="processing-payment-info">
          <button mat-raised-button color="primary" (click)="initiatePayment()" data-testid="dqf-proceed-to-pay">Proceed to Pay</button>
        </div>
      }
    </div>
  }
  <div #checkoutContainer class="checkout-container"></div>
</div>